import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { Observable } from 'rxjs';
import { EmployeeRoleTypes } from '../../enums/employees/EmployeeRoleTypes';
import { EmployeeUtil } from '../../utilities/employee.utilities';
import { ObjectTypes } from '../../enums/objectTypes';
import { ModuleTypes } from 'src/app/modules/settings/enums/moduleTypes';
import { GuardHelperService } from 'src/app/modules/auth/guard-helper.service';

@Injectable()
export class IMSGuard{
  constructor(
    private readonly authService: AuthenticationService,
    private readonly router: Router,
    private readonly guardHelperSvc: GuardHelperService
  ) {}

    canActivate(route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
    ): Observable<boolean> {
      return this.guardHelperSvc.canActivate(route, state, this.checkPermissions.bind(this));
    }

  checkPermissions(currentUrl:string): boolean {
    let result = false;
    const account = this.authService.getCurrentAccount();
    const employee = this.authService.getCurrentEmployee();
    const employeeHasIMSModuleAccess =
      EmployeeUtil.hasAccessToModule(employee, ModuleTypes.Incidents) || EmployeeUtil.IsAdmin(employee);
    const hasIncidentUserRole =
      EmployeeUtil.hasAccessToObjectType(employee, ObjectTypes.IncidentItem) || EmployeeUtil.IsAdmin(employee);

    if (!account.isActive) {
      void this.router.navigateByUrl(`${account.accountUID}/unauthorized`);
    }

    let useIMS = (account.useIMS || account.useIMSOnly);
    if(!useIMS|| !employeeHasIMSModuleAccess) {
      void this.router.navigateByUrl(`${account.accountUID}/mytrack/planning`);
      return false;
    }
    if(currentUrl.includes('control/list') || currentUrl.includes('control/logs') || currentUrl.includes('control/map') || currentUrl.includes('control/history')){
      result = account.useIncidents && hasIncidentUserRole;
      if(!result) {
        void this.router.navigateByUrl(`${account.accountUID}/mytrack/planning`);
      }
      return result;
    }
    if(currentUrl.includes('control/jobs') || currentUrl.includes('control/calendar')){
      const hasJobUserRole =
      EmployeeUtil.hasAccessToObjectType(employee, ObjectTypes.Job) || EmployeeUtil.IsAdmin(employee);
      result = account.useJobs && hasJobUserRole;
      if(!result) {
        void this.router.navigateByUrl(`${account.accountUID}/control/list`);
      }
      return result;
    }

    if(currentUrl.includes('control/incident-reports')){
      result = account.usePublicIncidentReporting;
      if(!result) {
        void this.router.navigateByUrl(`${account.accountUID}/control/list`);
      }
      return result;
    }

    else if((!account.usePublicIncidentReporting) && currentUrl.includes('control/incident-reports')){
      if(hasIncidentUserRole && account.useIncidents) {
        void this.router.navigateByUrl(`${account.accountUID}/control/list`);
      }
      return false;
    }

    if(currentUrl.includes('control/peaps')){
      const hasRole =
      EmployeeUtil.hasAccessToObjectType(employee, ObjectTypes.PEAP) || EmployeeUtil.IsAdmin(employee);
      result = account.usePeaps && hasRole;
      if(!result) {
        void this.router.navigateByUrl(`${account.accountUID}/control/list`);
      }
      return result;
    }

    if (useIMS && hasIncidentUserRole) {
      result = true;
    }



    if (!result) {
      void this.router.navigateByUrl(`${account.accountUID}/mytrack/planning`);
    }

    return result;
  }
}
